import React from "react";
import axios from "axios";
import { useForm } from "react-hook-form";

const ForgottenPasswordPage: React.FC = () => {
  const { register, handleSubmit, errors } = useForm();
  const onSubmit = async (data: { Email: string }) => {
    console.log(data);
    try {
      const response = await axios.post(
        `${process.env.GATSBY_STRAPI_URL}/auth/forgot-password`,
        {
          email: data.Email,
        }
      );
      console.log("Mail envoyé");
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="w-screen h-screen bg-gray-500 flex flex-col justify-center items-center">
      <div className="w-4/5 h-64 bg-white p-4">
        <div>Mot de passe oublie</div>
        <form
          className="flex h-full flex-col mt-4"
          onSubmit={handleSubmit(onSubmit)}
        >
          <input
            className="mt-4 p-2 focus:outline-none focus:border-2"
            type="text"
            placeholder="Email"
            name="Email"
            ref={register}
          />
          <input className="mt-6 p-2" type="submit" />
        </form>
      </div>
    </div>
  );
};

export default ForgottenPasswordPage;
